/**
 * Shared rule numbers (spec 02). Each stream keeps its own numbers in its own file
 * (`players/tuning.ts`, `bubbles/tuning.ts`, `monsters/tuning.ts`); this file holds only what
 * several share. Every number cites the spec section it comes from.
 */

/** Frames per second: the PAL C64's (02 §1.1). */
export const FRAME_HZ = 50;
/** A main-loop pass takes at least this many frames (02 §1.2); steady at this, like the arcade. */
export const FRAMES_PER_PASS = 3;

/** Seconds from the start of play to HURRY UP, by level (02 §6); null: no hurry on that level. */
export function hurrySeconds(levelNumber: number): number | null {
  // None on level 100, nor in the secret room (level 0, 02 §9.3: no time limit).
  if (levelNumber >= 100 || levelNumber <= 0) return null;
  if (levelNumber === 56) return 10;
  return levelNumber <= 55 ? 30 : 20;
}
/** Seconds from HURRY UP to the Baron (02 §6). */
export const BARON_SECONDS = 10;
/** Frames play freezes for the HURRY UP banner (02 §6: about 1.5 s). */
export const HURRY_FREEZE_FRAMES = 75;
/** Frames the game is frozen at level start while monsters drop in (02 §5: about 44 frames). */
export const DROP_IN_FREEZE_FRAMES = 44;
/** Frames from spelling EXTEND to the end of the round (02 §7.7: about 8 s). */
export const EXTEND_FRAMES = 8 * 50;
/** Frames of the level-clear countdown (02 §9.1: 9 s). */
export const CLEAR_FRAMES = 9 * 50;
/** Frames from touching the stunned boss to the ending: its 1,000,000 counted up over 100 frames, then a beat (02 §9.4). */
export const WON_FRAMES = 150;

/** Extra lives at these displayed scores, then every 1,000,000 up to 9,000,000 (02 §3). */
export const EXTRA_LIFE_AT: readonly number[] = [
  30_000, 100_000, 400_000, 1_000_000, 2_000_000, 3_000_000, 4_000_000, 5_000_000, 6_000_000, 7_000_000,
  8_000_000, 9_000_000,
];
/** Spare lives at the start (02 §3: 1 in play + 3). */
export const START_LIVES = 3;
/** The most spare lives the C64 can show and keep. */
export const MAX_LIVES = 7;
